import React, { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export const InlineTextReply = ({ endpoint, testid, onSent, placeholder = "Write a short reply…" }) => {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  if (!open) return <button type="button" data-testid={`${testid}-open`} onClick={() => setOpen(true)} className="mt-2 text-xs font-semibold" style={{ color: "var(--sj-primary)" }}>Reply by text</button>;
  const send = async () => {
    if (msg.trim().length < 2) return toast.error("Write a short reply first");
    setBusy(true);
    try { await api.post(endpoint, { message: msg.trim() }); toast.success("Reply sent — their number stays private"); setMsg(""); setOpen(false); onSent && onSent(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-2" data-testid={testid}>
      <textarea data-testid={`${testid}-input`} value={msg} onChange={(e) => setMsg(e.target.value)} maxLength={300} rows={2} placeholder={placeholder}
        className="w-full bg-white border border-[#EBE9E4] rounded-lg px-3 py-2 text-sm outline-none focus:border-[#0B5E4E]" />
      <div className="mt-1.5 flex items-center justify-end gap-2">
        <span className="text-xs mr-auto" style={{ color: "var(--sj-text-3)" }}>{msg.length}/300</span>
        <button type="button" data-testid={`${testid}-cancel`} onClick={() => setOpen(false)} className="rounded-full px-3 py-1.5 text-xs border" style={{ borderColor: "var(--sj-border)", color: "var(--sj-text-2)" }}>Cancel</button>
        <button type="button" data-testid={`${testid}-send`} disabled={busy} onClick={send} className="inline-flex items-center gap-1 rounded-full px-4 py-1.5 text-xs font-semibold text-white disabled:opacity-60" style={{ background: "var(--sj-primary)" }}><Send className="h-3.5 w-3.5" /> {busy ? "Sending…" : "Send"}</button>
      </div>
    </div>
  );
};
